import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';
import { RESOLVE_SIDELINE_TOOL } from 'src/models/unload';
import * as AppRoutes from 'src/routing/constants/routes';
import HomePage from 'src/components/pages/home-page/HomePageContainer';
import Identification from 'src/components/pages/identification-page/IdentificationContainer';
import Containerization from 'src/components/pages/containerization-page/ContainerizationContainer';
import Print from "src/components/pages/print-page/PrintContainer";
import Receive from "src/components/pages/receive-page/ReceiveContainer";
import Move from 'src/components/pages/move-page/MoveContainer';
import SendToProcess from 'src/components/pages/send-to-process-page/SendToProcessContainer';
import Search from 'src/components/pages/search-page/SearchContainer';
import Sortation from 'src/components/pages/sort-page/SortationContainer';
import Unload from 'src/components/pages/unload-page/UnloadContainer';
import UnloadChooser from 'src/components/pages/unload-page/chooser-page/UnloadChooserPageContainer';
import JackpotPage from 'src/components/pages/jackpot-page/JackpotPageContainer';
import {awsRum} from "src/serviceClients/aws-rum/awsRum-Service";

function AppRouter() {
    const location = useLocation();
    const resolvesSidelines = useSelector((state: RootState) =>
        state.Init.initData.associateDetails.accessibleTools.includes(RESOLVE_SIDELINE_TOOL));

    useEffect(() => {
        awsRum.recordPageView(location.pathname);
    }, [location.pathname]);

    return (
        <Routes>
            <Route path={AppRoutes.HOME_PAGE_ROUTE} element={<HomePage/>} />
            <Route path={AppRoutes.IDENTIFICATION_PAGE_ROUTE} element={<Identification/>} />
            <Route path={AppRoutes.CONTAINERIZATION_PAGE_ROUTE} element={<Containerization/>} />
            <Route path={AppRoutes.PRINT_PAGE_ROUTE} element={<Print/>} />
            <Route path={AppRoutes.RECEIVE_PAGE_ROUTE} element={<Receive/>} />
            <Route path={AppRoutes.MOVE_PAGE_ROUTE} element={<Move/>} />
            <Route path={AppRoutes.SEND_TO_PROCESS_PAGE_ROUTE} element={<SendToProcess/>} />
            <Route path={AppRoutes.SEARCH_PAGE_ROUTE} element={<Search/>} />
            <Route path={AppRoutes.SUB_SORT_PAGE_ROUTE} element={<Sortation/>} />
            <Route path={AppRoutes.UNLOAD_PAGE_ROUTE} element={<UnloadChooser/>} />
            <Route path={AppRoutes.UNLOAD_TRAILER_PAGE_ROUTE} element={<Unload/>} />
            <Route path={AppRoutes.UNLOAD_PALLET_PAGE_ROUTE} element={<Unload/>} />
            {/* Only a problem solver resolves sideline IDs; anyone else who opens it lands on the chooser */}
            <Route path={AppRoutes.UNLOAD_RESOLVE_PAGE_ROUTE}
                element={resolvesSidelines ? <Unload/> : <Navigate to={AppRoutes.UNLOAD_PAGE_ROUTE} replace/>} />
            <Route path={AppRoutes.JACKPOT_PAGE_ROUTE} element={<JackpotPage/>} />
        </Routes>
    );
}

export default AppRouter;